import type {
  OgcOnboardingMode,
  ResourceServerId,
} from '../dataset-home/dataset-home.models';

export const OGC_RASTER_STAC_STEPS = [
  { key: 'collection', label: 'Collection' },
  { key: 'item', label: 'Item' },
] as const;

export function isOgcRasterOnboarding(
  resourceServer: ResourceServerId,
  ogcOnboardingMode: OgcOnboardingMode | null | undefined,
): boolean {
  return resourceServer === 'ogc' && ogcOnboardingMode === 'raster';
}

export function maxWizardStep(isOgcRaster: boolean): number {
  return isOgcRaster ? 3 : 1;
}

export function parseWizardStepParam(
  raw: string | null,
  maxStep: number,
): number {
  const parsed = Number.parseInt(raw ?? '0', 10);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  return Math.min(Math.max(0, parsed), maxStep);
}
